<template>
  <div
    key="dontLockout"
    :class="[$style.inputRow, $style.revealedRowPosition]"
  >
    <CheckboxWithLabel
      key="dontLockoutOnDeviceLoginFailures"
      :data-test-id="$testId('preventLockout')"
      label="Bypass account lockout policy for user’s managed device"
      labelSubText="Managed device login failures will not trigger account lockout."
      name="Do not Lockout Device"
      preventDefault
      :value="value"
      @change="handleChange"
    />
  </div>
</template>

<script>
import CheckboxWithLabel from 'client/components/FormValidation/CheckboxWithLabel';

export default {
  name: 'AccountLockout',

  components: {
    CheckboxWithLabel,
  },

  disableDeviceLockoutTooltip: {
    text: 'This does not exclude the user from user portal or change password failed logon attempts.  It only excludes the device logon attempts.',
  },

  emits: ['change'],

  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },

  methods: {
    handleChange(checked) {
      this.$emit('change', checked);
    },
  },
};
</script>

<style module>
@import '../../../css/flex.css';
@import '../../../components/FormValidation/css/formFields.css';

.revealedRowPosition {
  margin-bottom: 1rem;
}
</style>
